import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyBiBAf4r8sUNHZk7ReKpzNGrJ8koNhnIQM",
    authDomain: "ptts-certificates.firebaseapp.com",
    projectId: "ptts-certificates",
    storageBucket: "ptts-certificates.appspot.com",
    messagingSenderId: "561534427541",
    appId: "1:561534427541:web:e078d230eaa3d3f176d69c",
    measurementId: "G-WBBP8X2B3W"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  isSupported().then((isSupported) => {
    if (isSupported) {
      getAnalytics(app);
    }
  });
 